import { ImageTypes } from "~enums/imageTypes";
import type { Person } from "~types/person";
import type { RoleResponse } from "~types/role";
import { findImageByType } from "~utilities/findImageByType";

export const transformRoleResponse = (responseData: RoleResponse) => {
  const resources = responseData.includes?.resources;
  return responseData.data.map((role) => {
    const resourcePerson = (resources?.[role.person.resourceType] as { [id: string]: Person })?.[role.person.id];
    const avatarUrl = findImageByType(resourcePerson?.images, ImageTypes.PersonHead) ?? "";
    return {
      avatarUrl,
      nameFullLocal: resourcePerson?.nameFullLocal ?? "",
      personId: resourcePerson?.personId ?? "",
      role: role.role,
      roleId: role.roleId,
      status: role.status ?? "",
      nationality: resourcePerson?.nationality ?? "",
      gender: resourcePerson?.gender ?? "",
    };
  });
};
